import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import {
  IExternalContactMedium,
  IOrderInfoSalesOrderAccepter,
} from '../utils/types';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { EditTwoTone } from '@mui/icons-material';
import React, { useState } from 'react';
import AddInvoiceAddressDialog from './AddInvoiceAddressDialog';
type OrderInfoSalesOrderAccepterProps = {
  salesOrderAccepter: IOrderInfoSalesOrderAccepter[];
  salesIndividualId: string;
};

export default function OrderInfoSalesOrderAccepter({
  salesOrderAccepter,
  salesIndividualId,
}: OrderInfoSalesOrderAccepterProps) {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [selectedProgram, setSelectedProgram] = useState<
    IExternalContactMedium | undefined
  >();
  const editLoyaltyProgramItem = async (program?: IExternalContactMedium) => {
    setSelectedProgram(program);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedProgram(undefined);
  };

  const handleSaveLoyaltyProgram = async () => {
    setOpenDialog(false);
  };

  return (
    <Grid2 container spacing={2} mt={2}>
      {salesOrderAccepter.map((salesOrderAccepterItem) => (
        <Grid2 key={salesOrderAccepterItem.id} xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="h6">
                  {salesOrderAccepterItem.role?.name}
                </Typography>
                {salesOrderAccepterItem.externalContactMedium && (
                  <Button
                    size="small"
                    color="secondary"
                    sx={{ mt: 0.5 }}
                    onClick={() => editLoyaltyProgramItem()}
                  >
                    <EditTwoTone />
                  </Button>
                )}
              </Box>

              <Typography variant="body1">
                {salesOrderAccepterItem.externalContactMedium?.owner
                  ? salesOrderAccepterItem.externalContactMedium?.owner
                  : salesOrderAccepterItem.party?.partyInfo?.firstName +
                    ' ' +
                    salesOrderAccepterItem.party?.partyInfo?.lastName}
              </Typography>
              <Typography variant="body1">
                {salesOrderAccepterItem.party?.partyInfo?.name}
              </Typography>
              <Typography variant="body1">
                {salesOrderAccepterItem.externalContactMedium?.postalAddress
                  ?.fullAddress
                  ? salesOrderAccepterItem.externalContactMedium?.postalAddress
                      ?.fullAddress
                  : salesOrderAccepterItem.address?.fullAddress}
              </Typography>
              <Typography variant="body1">
                {salesOrderAccepterItem.externalContactMedium?.phoneNumber
                  ?.fullNumber
                  ? salesOrderAccepterItem.externalContactMedium?.phoneNumber
                      ?.fullNumber
                  : salesOrderAccepterItem.phoneNumber?.countryCode +
                    ' ' +
                    salesOrderAccepterItem.phoneNumber?.phoneNumber}
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
      ))}
      <AddInvoiceAddressDialog
        open={openDialog}
        onClose={handleDialogClose}
        program={selectedProgram}
        onSave={handleSaveLoyaltyProgram}
        salesIndividualId={salesIndividualId}
      />
    </Grid2>
  );
}
